import { useAppFlags } from '@/hooks/useAppFlags';

/** The Clear objective is available when the backend computes clear spans at runtime. */
export const useShowClearSpanAnalysis = (): boolean => {
  const { flagComputeClearSpansAtRuntime } = useAppFlags();

  return flagComputeClearSpansAtRuntime;
};
